<template>
  <div class="rc-multiple-tabs-runtime">
    <div class="multiple-tabs-title el-tabs el-tabs--card el-tabs--top">
      <div class="el-tabs__header is-top multiple-tabs-header">
        <div class="el-tabs__nav-wrap is-top">
          <div class="el-tabs__nav-scroll">
            <div role="tablist" class="el-tabs__nav is-top" style="transform: translateX(0px);">
              <div class="el-tabs__item is-top" :class="component.properties.activeIndex == index  ? 'is-active':''"  v-for='(tabName, index) in component.properties.tabList' :key='index' @click="changeTab(index)">{{component.properties.tabList[index]}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="el-tabs__content">
        <div
          class="list-component-item multiple-tabs-list-item"
          v-for="component in component.children" :key="component.id">
          <div v-show="showComponent(component)">
            <component
              ref="children"
              v-if="!component.properties.hidden"
              :is="component.componentType"
              :component="component"
              :disabled="disabled"
              :value="getChildrenData(component)"
              :parentPath="getCurrentPath()"
              :dialogWidth="dialogWidth"
              @initRelated="initRelated"
              @initDefaultValue="(component, callback) => callbackDefault(component, {'callback': callback})"
              @calculation="(expression) => calculation(expression)">
            </component>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {containerInitMixin, componentMixin, containerMixin, calculationMixin, relFunMixin, defaultValueMixin} from './mixins'
import {ruleGenerator} from './rule'

export default {
  name: 'rc-multiple-tabs',
  mixins: [componentMixin, containerMixin, calculationMixin, relFunMixin, ruleGenerator, defaultValueMixin, containerInitMixin],
  props: ['component', 'value', 'dialogWidth', 'disabled'],
  components: {
    'rc-layout': () => import('./rc-layout')
  },
  data () {
    return {
      isContainerInit: true
    }
  },
  created () {
    this.changeTab(0)
  },
  methods: {
    changeTab (index) {
      this.component.properties.activeIndex = index
    },
    initRelated (component) {
      this.$emit('initRelated', component)
    },
    initDefaultValue (component, callback) {
      this.$emit('initDefaultValue', component, callback)
    }
  },
  computed: {
    showComponent () {
      return component => this.component.properties.tabCompnents[this.component.properties.activeIndex].includes(component.id)
    }
  }
}
</script>
<style lang='scss' scoped>
.rc-multiple-tabs-runtime{
  background: white;
  margin-bottom: 20px;
  .el-tab-pane{
    min-height: 50px;
  }
    .multiple-tabs-title{
      .multiple-tabs-header{
        position: relative;
        top: 8px;
        z-index: 100;
      }
      .el-tabs__nav-scroll{
        overflow-x: scroll;
        .el-tabs__nav{
          display: flex;
          border: none;
        }
      }
      .el-tabs__header{
        margin:0px;
        border: none;
        .el-tabs__item{
          background: #f7f7f7;
          margin-right: 10px;
          border: 1px solid #EBEBEB;
          border-bottom: none;
          border-radius: 5px 5px 0px 0px;
          font-size: 14px;
        }
        .is-active{
          background: white;
        }
      }
      .el-tabs__content{
        min-height: 80px;
        padding: 15px 0px;
        border-top: 1px solid #E4E7ED;
        .multiple-tabs-list-item{
          padding: 0px;
        }
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-multiple-tabs.vue